import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface GuidePageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function GuidePageHeader({ title, subtitle, actions }: GuidePageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Typography
          variant="h5"
          fontWeight={800}
          letterSpacing="-0.02em"
          sx={{ fontSize: { xs: '1.35rem', md: '1.5rem' } }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 560 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions}
    </Box>
  );
}
